import { DonationReportOutput } from 'gql/types';
import { TFunction } from 'i18next';
import { ReportFilterOptions } from 'modules/reports/hooks/useReportFilterOptions';
import { ReportFilterConfig } from 'modules/reports/types';

export const getDonationReportFilters = (
  t: TFunction,
  { regionNames, locationNames }: ReportFilterOptions
): ReportFilterConfig<DonationReportOutput>[] => [
  {
    key: 'donationDate',
    label: t('donationDate'),
    type: 'dateRange',
    getValue: (item) => item.donationDate,
  },
  {
    key: 'donorRegion',
    label: t('donorRegion'),
    type: 'multiselect',
    getValue: (item) => item.donor?.region,
    options: regionNames,
  },
  {
    key: 'donorLocation',
    label: t('donorLocation'),
    type: 'multiselect',
    getValue: (item) => item.donor?.location,
    options: locationNames,
  },
];
